import { render, staticRenderFns } from "./menus-manager.vue?vue&type=template&id=2fff9e40&"
import script from "./menus-manager.vue?vue&type=script&lang=js&"
export * from "./menus-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports